import { useCallback, useState } from 'react';

/**
 * The modal holds controlled state above the Rovo swap because switching columns unmounts sections.
 * The panel and popup use local state.
 * Share this split so shell bodies and capped lists preserve expansion in the same way.
 */
export const useExpandedState = (
	controlledExpanded: boolean | undefined,
	onToggle: (() => void) | undefined,
	defaultExpanded = false,
): readonly [boolean, () => void] => {
	const [uncontrolledExpanded, setUncontrolledExpanded] = useState(defaultExpanded);
	const isControlled = controlledExpanded !== undefined;

	const toggle = useCallback(() => {
		if (isControlled) {
			onToggle?.();
		} else {
			setUncontrolledExpanded((prev) => !prev);
		}
	}, [isControlled, onToggle]);

	return [isControlled ? controlledExpanded : uncontrolledExpanded, toggle];
};
